export { default } from './CautionTriangle'
